import layout from '@/layout/index'
import chargingMonitor from '@/module/operatingCenter/page/chargingMonitor'
import RateManager from '@/module/resourceCenter/page/rateManager.vue'

// 导出配置的路由器
export default [{
    // 默认进入此页面
    path: '/operatingCenter',
    component: layout,
    redirect: 'operatingCenter/chargingMonitor',
    meta: {
        title: '运营中心',
        icon: 'icon-yingxiao1',
        perms: ['bee:operating']
    },
    children: [{
            path: 'chargingMonitor',
            component: chargingMonitor,
            meta: {
                icon: 'icon-yingxiao1',
                title: '充电监控',
                perms: ['bee:res:chargingMonitor']
            }
        }
        // , {
        //     path: 'siteMonitor',
        //     component: siteMonitor,
        //     meta: {
        //         icon: 'icon-yunshuchangzhan',
        //         title: '场站监控',
        //         perms: ['bee:order:siteMonitor']
        //     }
        // }
      ,{
        path: 'rateManager',
        component: RateManager,
        meta: {
          title: '费率管理',
          icon: 'icon-feishuaiguanli',
          perms: ['bee:res:rate']
        }
      },
      {
        path: 'ChargingCardList',
        component: () => import('@/module/cardManage/page/ChargingCard/list.vue'),
        meta: {
          title: '充电卡管理',
          icon: 'icon-qia2',
          perms: ['bee:member:card']
        }
      },
      {
        path: 'pushParkRecord',
        component: () =>
          import ("@/module/operatingCenter/page/pushPark/pushParkManage.vue"),
        meta: {
          icon: 'icon-caozuo',
          title: '停车减免',
          perms: ['bee:ops:pushPark']
        }
      },
    ]
}]



// WEBPACK FOOTER //
// ./src/module/operatingCenter/router/index.js